import { render, staticRenderFns } from "./QuestionHelper.vue?vue&type=template&id=10972bd1&scoped=true&"
import script from "./QuestionHelper.vue?vue&type=script&lang=js&"
export * from "./QuestionHelper.vue?vue&type=script&lang=js&"
import style0 from "./QuestionHelper.vue?vue&type=style&index=0&id=10972bd1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10972bd1",
  null
  
)

export default component.exports